import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'completionStatusId',
    'componentTypeId',
    'addButton'
  ];

  connect() {
    this.rowTemplate = this.element.querySelector('[data-template="row"]');
    this.rowsSection = this.element.querySelector('.rows-section');
  }

  addMapping(event) {
    event.preventDefault();
    const completionStatusId = this.completionStatusIdTarget.value;
    const componentTypeId = this.componentTypeIdTarget.value;
    const temp = document.createElement('div');

    temp.appendChild(this.rowTemplate.content.cloneNode(true));
    temp.firstElementChild.children[0].textContent = componentTypeId;
    temp.firstElementChild.children[1].textContent = completionStatusId;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `integration[config][type_status_map][${componentTypeId}]`;
    input.value = completionStatusId;
    temp.firstElementChild.appendChild(input);

    this.completionStatusIdTarget.value = '';
    this.componentTypeIdTarget.value = '';

    this.rowsSection.appendChild(temp.firstElementChild);
    this.addButtonTarget.disabled = true;
  }

  removeMapping(event) {
    event.preventDefault();
    event.target.closest('.js-table-body-row').remove();
  }

  toggleAddButton() {
    if (this.completionStatusIdTarget.value && this.componentTypeIdTarget.value) {
      this.addButtonTarget.disabled = false;
    } else {
      this.addButtonTarget.disabled = true;
    }
  }
}
